"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var reactstrap_1 = require("reactstrap");
var Components_1 = require("./Components");
var Tabs_1 = require("./Tabs");
var Context_1 = require("../../Context");
require("react-bootstrap-table-next/dist/react-bootstrap-table2.min.css");
require("react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css");
var Components_2 = require("../../Components");
var History_1 = require("../../Utils/History");
var SettingsTabId;
(function (SettingsTabId) {
    SettingsTabId[SettingsTabId["Locations"] = 0] = "Locations";
    SettingsTabId[SettingsTabId["Users"] = 1] = "Users";
})(SettingsTabId = exports.SettingsTabId || (exports.SettingsTabId = {}));
var Settings = /** @class */ (function (_super) {
    __extends(Settings, _super);
    function Settings(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function (tab) {
            _this.setState({
                activeTab: tab
            }, function () { return History_1.default.push(tab == SettingsTabId.Users ? '/Settings/Users' : '/Settings/Locations'); });
        };
        _this.state = {
            activeTab: SettingsTabId.Locations
        };
        return _this;
    }
    Settings.prototype.componentDidMount = function () {
        if (window.location.pathname.endsWith('Users')) {
            this.setState({ activeTab: SettingsTabId.Users });
        }
        else if (window.location.pathname.endsWith('Locations')) {
            this.setState({ activeTab: SettingsTabId.Locations });
        }
        else {
            History_1.default.push('/Settings/Locations');
        }
    };
    Settings.prototype.render = function () {
        var _this = this;
        return (React.createElement(Context_1.GlobalConsumer, null, function (context) { return context && context.userInfo.UserRole.match(/Administrator/g) ? (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: '/Settings*', render: function () {
                    return React.createElement(reactstrap_1.Col, null,
                        React.createElement(reactstrap_1.Row, { className: "h-100" },
                            React.createElement(reactstrap_1.Col, null,
                                React.createElement(reactstrap_1.Nav, { tabs: true },
                                    React.createElement(reactstrap_1.NavbarBrand, null, context.resources.Settings),
                                    React.createElement(Components_1.SettingsTab, { activeTab: _this.state.activeTab, onClick: _this.toggle, tabId: SettingsTabId.Locations, tabTitle: context.resources.Locations }),
                                    React.createElement(Components_1.SettingsTab, { activeTab: _this.state.activeTab, onClick: _this.toggle, tabId: SettingsTabId.Users, tabTitle: context.resources.Users })))),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null,
                                React.createElement(reactstrap_1.TabContent, { id: "settings-tab-content", activeTab: _this.state.activeTab },
                                    React.createElement(Components_1.SettingsTabContent, { tabId: SettingsTabId.Locations },
                                        React.createElement(Tabs_1.Locations, { applicationData: context })),
                                    React.createElement(Components_1.SettingsTabContent, { tabId: SettingsTabId.Users },
                                        React.createElement(Tabs_1.Users, { applicationData: context }))))));
                } }))) : (React.createElement(Components_2.SafeRedirect, { to: "/Dashboard/Safe", resources: context.resources })); }));
    };
    return Settings;
}(React.Component));
exports.Settings = Settings;
//# sourceMappingURL=Settings.js.map